import { useSelector } from "react-redux"
import { FirstThreeSection, ColumnWrapper, ColumnHeader, ColumnBodyText, ColumnImage, LearnMore } from "./FirstThreeColumnsStyle"
import image1 from "./01_images/column1.jpg"
import image2 from "./01_images/column2.jpg"
import image3 from "./01_images/column3.jpg"
import { about } from "../../../i18n/03_about"

const FirstThreeColumns = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = about[lang]

    const firstImages = [image1, image2, image3]

    return (
        <FirstThreeSection>
            {t.firstColumnWrapper.map((value, index) => (
                    <ColumnWrapper key={index}>
                        <ColumnImage src={firstImages[index]} />
                        <ColumnHeader>
                            {value.columnHeader}
                        </ColumnHeader>
                        <ColumnBodyText>
                            {value.columnBodyText}
                        </ColumnBodyText>
                        <LearnMore to={value.learnMoreTo}>
                            {value.learnMoreText}
                        </LearnMore>
                    </ColumnWrapper>
            ))}
        </FirstThreeSection>
    )
}

export default FirstThreeColumns